/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'JerseyCTF IV (2024)',
        title: '40/520',
        text: "",
        image: "https://ctftime.org/media/cache/4c/74/4c74ec91472ae6a1dd5b07f6784d7fe3.png"
    },
    {
        id: 2,
        name: 'SpringForwardCTF (2024)',
        title: '35/446',
        text: "",
        image: "https://ctftime.org/media/cache/d9/4e/d94e29f932e0a8baad05823533fa09ec.png"
    },
    {
        id: 3,
        name: 'DEADFACE CTF (2024)',
        title: '188/1213',
        text: "",
        image: "https://ctftime.org/media/cache/99/3c/993cef1748c9dde0fdb6c4bf46c32c27.png"
    },
    {
        id: 4,
        name: 'SpookyCTF (2024)',
        title: '85/831',
        text: "",
        image: "https://ctftime.org/media/cache/c5/01/c50150283df5e7263aee54c5b2b7a2ad.png"
    },
    {
        id: 5,
        name: 'Hackers n\' Hops (2024)',
        title: '39/339',
        text: '',
        image: "https://ctftime.org/media/cache/24/09/2409161fc9b1f441d6d43f844c03a38f.png"
    },
    {
        id: 6,
        name: 'BambiCTF #11 (2024)',
        title: '52/53',
        text: "",
        image: "https://ctftime.org/media/cache/da/99/da999437f677014cdad247315fcdfb88.png"
    }, 
    {
        id: 7,
        name: 'JerseyCTF V (2025)',
        title: '21/406',
        text: "",
        image: "https://ctftime.org/media/cache/d5/2f/d52fa39915f13ee213c1e6501eaa132c.png"
    }, 
    {
        id: 8,
        name: 'JerseyCTF VI (2026)',
        title: '59/398',
        text: "",
        image: "https://ctftime.org/media/cache/61/92/61924da69760a794338b051f2368b9d2.png"
    }
]

